"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./index.css");
require("lazysizes");
require("lazysizes/plugins/parent-fit/ls.parent-fit");
const define_components_1 = require("./scripts/utils/define-components");
if (Shopify.designMode) {
    document.documentElement.className = `${document.documentElement.className} is-editor-mode`;
}
(0, define_components_1.defineComponents)();
